import * as React from 'react';
import {TypeImplementation, Plugins} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TText, type Expression} from '@packages/systems/wfdl-ast';
import {Button, EditIcon} from '@packages/systems/spring';
import {useDispatch} from '@packages/systems/designer/flux';
import {
  updateExpressionAction,
  useExpressionEditorContext,
} from '@packages/systems/ExpressionEditor-utils';
import {stripAll} from '@packages/utilities/contextual-expression';
import {embedEditorShown} from '@packages/systems/designer/embed-editor';

export const CodePluginType = TypeImplementation.Unique({
  type: TText,
  render: function CodePluginTypeRender({expr, dispatch}) {
    const wfDispatch = useDispatch();
    // 'field-editor' means we're editing the component definition's default
    // value — bindings are page-contextual and can't persist there.
    const editorContext = useExpressionEditorContext();
    const isEditingDefault = editorContext === 'field-editor';

    const openEditor = () => {
      const onSave = (newExpr: Expression) => {
        dispatch(updateExpressionAction(newExpr));
      };

      wfDispatch(
        embedEditorShown({
          source: 'button',
          onSave,
          initialExpr: stripAll(expr),
          showBindingDot: !isEditingDefault,
          isEditingDefault,
        })
      );
    };

    return (
      <Button
        isFullWidth
        data-automation-id="OpenCodeEditor"
        onClick={openEditor}
        prefix={<EditIcon size={12} />}
      >
        Edit code
      </Button>
    );
  },
  system: {
    label: 'Code',
    displayName: 'Code',
    defaultValue: '',
  },
  icon: TypeImplementation.IconByName(
    qualify(Plugins.name('Embed'), iconName('Code'))
  ),
});
